import styled from "styled-components";
import { theme } from "../../styles/theme.style";

export const SContentBoxList = styled.ul`
  margin-top: ${theme.spacing.base};
  max-width: 90rem;
  margin-left: auto;
  margin-right: auto;
`;
